import { Message } from './message.js';
import { CacheUtils } from './cache-utils.js';
export class RESTUtils {
    static { this.ggo_token = ''; }
    static { this.getRequestHeders = (headers = {}) => {
        headers['Content-Type'] = 'application/json';
        headers.Authorization = `Bearer ${this.getToken()}`;
        return headers;
    }; }
    static setToken(token) {
        RESTUtils.ggo_token = token;
        window.localStorage.setItem('ggo_token', token);
    }
    static getToken() {
        // check URL parameter
        const urlToken = this.getUrlParameter('ggo_token');
        if (urlToken && urlToken.length > 0) {
            this.setToken(urlToken);
            // Stocker dans le local storage
            window.localStorage.setItem('ggo_token', urlToken);
            // Supprimer le paramètre de l'URL sans recharger la page
            const url = new URL(window.location.href);
            url.searchParams.delete('ggo_token');
            window.history.replaceState({}, '', url.toString());
            return urlToken;
        }
        // Si pas dans l'URL, lire dans le local storage
        const localToken = window.localStorage.getItem('ggo_token');
        if (localToken && localToken.length > 0) {
            this.setToken(localToken);
            return localToken;
        }
        return RESTUtils.ggo_token;
    }
    static async getJson(url, opts) {
        if (opts?.cache === true) {
            const cache = CacheUtils.getCache(url);
            if (cache) {
                return cache;
            }
        }
        else {
            url = this.setUrlParameter(url, 'ts', Date.now());
        }
        try {
            //url = this.setUrlParameter(url, 'token', this.getToken()); // DO NOT COMMIT
            const response = await fetch(url, {
                method: 'GET',
                headers: this.getRequestHeders(opts?.headers ?? {}),
                mode: 'cors',
            });
            const result = await response.json();
            if (result.redirectUrl) {
                this.handleNotLoggedIn(result);
            }
            if ((result?.success !== undefined && !result.success) || result.code === 500 || result.code === 401) {
                this.handleError(result, response.status, opts);
                throw result;
            }
            if (opts?.cache === true) {
                CacheUtils.setCache(url, result);
            }
            return result;
        }
        catch (error) {
            console.error(`Error fetching ${url}`, error);
            this.handleError(error, 500, opts);
            throw error;
        }
    }
    static getUrlParameter(param) {
        const url = new URL(window.location.href);
        return url.searchParams.get(param);
    }
    static async postJson(url, body, opts) {
        let requestBody;
        let headers = this.getRequestHeders(opts?.headers ?? {});
        if (opts?.formUrlEncoded) {
            headers['Content-Type'] = 'application/x-www-form-urlencoded';
            requestBody = Object.keys(body)
                .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(body[key])}`)
                .join('&');
        }
        else {
            requestBody = JSON.stringify(body);
        }
        const request_options = {
            headers,
            method: 'POST',
            mode: 'cors',
            body: requestBody,
            ...(opts?.headers ?? {}),
        };
        try {
            const response = await fetch(url, request_options);
            const result = await response.json();
            if ((result?.success !== undefined && !result.success) || response.status === 500 || response.status === 401) {
                this.handleError(result, response.status, opts);
                throw result;
            }
            return result;
        }
        catch (error) {
            console.error(`Error fetching ${url}`, error);
            if (opts?.handleError)
                this.handleError(error, 500, opts);
            throw error;
        }
    }
    static async deleteJson(url, headers = {}) {
        console.log('DELETE', url);
        const request_options = {
            headers: this.getRequestHeders(headers),
            method: 'DELETE',
            mode: 'cors',
            ...headers,
        };
        try {
            const response = await fetch(url, request_options);
            return await response.json();
        }
        catch (error) {
            console.error(`Error fetching ${url}`, error);
            throw error;
        }
    }
    static async putJson(url, body, headers = {}) {
        console.log('PUT', url, body);
        const request_options = {
            headers: this.getRequestHeders(headers),
            method: 'PUT',
            mode: 'cors',
            body: JSON.stringify(body),
            ...headers,
        };
        try {
            const response = await fetch(url, request_options);
            return await response.json();
        }
        catch (error) {
            console.error(`Error fetching ${url}`, error);
            throw error;
        }
    }
    /**
     *
     * Add a parameter to the input URL
     *
     * @param url input URL
     * @param key
     * @param value
     * @returns
     */
    static setUrlParameter(url, key, value) {
        if (value === undefined) {
            return url;
        }
        if (url.indexOf('?') > 0) {
            return `${url}&${key}=${encodeURIComponent(value)}`;
        }
        else {
            return `${url}?${key}=${encodeURIComponent(value)}`;
        }
    }
    /**
     * Ajoute un paramètre à l'URL de la page courante sans la recharger.
     *
     * @param {string} key - Le nom du paramètre.
     * @param {string} value - La valeur du paramètre.
     */
    static addUrlParameter(key, value) {
        // Obtenir l'URL actuelle
        const url = new URL(window.location.href);
        // Ajouter ou mettre à jour le paramètre
        url.searchParams.set(key, value);
        // Mettre à jour l'URL sans recharger la page
        window.history.pushState({}, '', url);
    }
    static async handleNotLoggedIn(user) {
        const currentUrl = new URL(window.location.href);
        let orgId = currentUrl.searchParams.get('orgId');
        if (!orgId && user?.orgId) {
            orgId = user.orgId;
        }
        if (!user.redirectUrl && !user.platformUrl) {
            Message.alert("You are not logged in");
            return;
        }
        let redirectUrlString = user.redirectUrl ?? user.platformUrl + '/viewer/login.html?orgId=' + (orgId || '');
        if (redirectUrlString) {
            // remove the ggo_token parameter from the redirect URL
            const redirectUrl = new URL(redirectUrlString);
            redirectUrl.searchParams.delete('ggo_token');
            redirectUrl.searchParams.delete('orgId');
            if (orgId) {
                redirectUrl.searchParams.append('orgId', orgId);
            }
            currentUrl.searchParams.delete('ggo_token');
            currentUrl.searchParams.delete('orgId');
            // if (orgId) {
            //   redirectUrl.searchParams.append('msg', encodeURIComponent(Translate.get('enter_credentials_to') + orgId));
            // }
            redirectUrl.searchParams.append('redirect', currentUrl.href);
            window.location.href = redirectUrl.href.toString();
        }
        Message.alert("You are not logged in");
    }
    static handleError(error, status = 200, opts) {
        const showAlert = opts?.handleError === undefined || opts.handleError === true;
        if (!showAlert) {
            console.error('Error:', error);
            return;
        }
        if (status && status === 401) {
            this.handleNotLoggedIn(error);
            return;
        }
        if (error.message) {
            Message.alert(error.message);
        }
        else {
            Message.alert('An error occured');
        }
    }
}
